<div class="subject-management-create-section-card"
  [class.subject-management-create-section-card-project]="isProjectResearch"
  [class.subject-management-create-section-card-collapsed]="collapsible && !expanded" [formGroup]="section">
  <button *ngIf="collapsible" type="button" class="subject-management-create-section-collapse-toggle"
    [attr.aria-expanded]="expanded" (click)="onToggleExpanded()">
    <div class="subject-management-create-section-collapse-summary">
      <div class="subject-management-create-section-collapse-title">
        <span class="subject-management-create-section-preview-label">Section :</span>
        <span>{{ getPreviewValue('section') }}</span>
        <app-subject-management-status-badge
          *ngIf="showStatus || submitted"
          [label]="statusLabel"
          [status]="status"
          size="section"
        ></app-subject-management-status-badge>
      </div>
      <div class="subject-management-create-section-collapse-subtitle" *ngIf="!isProjectResearch">
        <span class="subject-management-create-section-preview-label">ประเภทการสอน :</span>
        <span>{{ getCollapsedTeachingTypeLabel() }}</span>
      </div>
    </div>
    <span class="subject-management-create-section-chevron" [class.is-expanded]="expanded" aria-hidden="true"></span>
  </button>

  <div class="subject-management-create-section-card-content" *ngIf="!collapsible || expanded">
    <div class="subject-management-create-section-card-actions"
      *ngIf="!collapsible && ((removable && !submitted) || (showTopStatusBadge && (showStatus || submitted)))">
      <button *ngIf="removable && !submitted" type="button"
        class="app-button app-button-primary subject-management-create-delete-section-button"
        (click)="requestRemove.emit()">
        <img src="assets/media/icons/svg/trush.svg" alt="" aria-hidden="true" />
        <span>ลบ Section</span>
      </button>
      <app-subject-management-status-badge
        *ngIf="showTopStatusBadge && (showStatus || submitted)"
        [label]="statusLabel"
        [status]="status"
        size="section"
      ></app-subject-management-status-badge>
    </div>

    <ng-container *ngIf="previewMode; else editableSectionFields">
      <div class="subject-management-create-section-preview">
        <div class="subject-management-create-section-preview-title">
          <span class="subject-management-create-section-preview-label">Section :</span>
          <span>{{ getPreviewValue('section') }}</span>
          <app-subject-management-status-badge
            *ngIf="!collapsible"
            [label]="statusLabel"
            [status]="status"
            size="section"
          ></app-subject-management-status-badge>
        </div>
        <div class="subject-management-create-section-preview-grid">
          <div class="subject-management-create-section-preview-item" *ngIf="!isProjectResearch">
            <span class="subject-management-create-section-preview-label">ประเภทการสอน :</span>
            <span>{{ getPreviewValue('teachingType') }}</span>
          </div>
          <div class="subject-management-create-section-preview-item" *ngIf="!isProjectResearch">
            <span class="subject-management-create-section-preview-label">ห้องเรียน :</span>
            <span>{{ getPreviewValue('room') }}</span>
          </div>
          <div class="subject-management-create-section-preview-item" *ngIf="!isProjectResearch">
            <span class="subject-management-create-section-preview-label">จำนวนนักศึกษา :</span>
            <span>{{ getPreviewValue('studentCount') }}</span>
          </div>
          <div class="subject-management-create-section-preview-item" *ngIf="!isProjectResearch">
            <span class="subject-management-create-section-preview-label">ชั่วโมงที่สอน (ไม่เกิน 15 สัปดาห์) :</span>
            <span>{{ getPreviewValue('workloadHours') }}</span>
          </div>
          <ng-container *ngIf="!isProjectResearch">
            <div class="subject-management-create-section-preview-item subject-management-create-section-preview-item-wide"
              *ngFor="let line of getTeachingTimePreviewLines()">
              <span class="subject-management-create-section-preview-label">วันที่สอน :</span>
              <span>{{ line }}</span>
            </div>
          </ng-container>
          <div class="subject-management-create-section-preview-item subject-management-create-section-preview-item-wide"
            *ngIf="!isProjectResearch">
            <span class="subject-management-create-section-preview-label">การคิดภาระงานสอน (ชั่วโมง) :</span>
            <span>{{ workloadModeLabel }}</span>
          </div>
        </div>
      </div>
    </ng-container>

  <ng-template #editableSectionFields>
    <div class="subject-management-create-section-grid">
      <div class="subject-management-create-field subject-management-create-field-sm subject-management-create-section-field-number">
        <label class="subject-management-create-label" [for]="'section-' + sectionIndex">
          Section <span aria-hidden="true">*</span>
        </label>
        <input [id]="'section-' + sectionIndex" type="text" inputmode="numeric" pattern="[0-9]*"
          class="form-control subject-management-create-input" formControlName="section" autocomplete="off"
          [readonly]="!sectionFieldsEditable" [class.is-invalid]="getSectionError()" (keydown)="onDigitsOnlyKeydown($event)"
          (input)="onDigitsOnlyInput($event, section.get('section'))" />
        <div class="invalid-feedback" *ngIf="getSectionError()">{{ getSectionError() }}</div>
      </div>

      <div class="subject-management-create-field subject-management-create-field-sm subject-management-create-section-field-type"
        *ngIf="!isProjectResearch">
        <app-select label="ประเภทการสอน" formControlName="teachingType" [required]="true"
          [options]="teachingTypeOptions" bindLabel="label" bindValue="id" [searchable]="false"
          [clearable]="sectionFieldsEditable" [isDisabled]="!sectionFieldsEditable" [error]="hasSectionError('teachingType')" errorMessage="กรุณากรอกข้อมูล"
          inputClass="subject-management-create-select" classes="mb-0"></app-select>
      </div>

      <div class="subject-management-create-field subject-management-create-field-sm subject-management-create-section-field-room"
        *ngIf="!isProjectResearch">
        <label class="subject-management-create-label" [for]="'section-room-' + sectionIndex">
          ห้องเรียน
        </label>
        <input [id]="'section-room-' + sectionIndex" type="text" autocomplete="off"
          class="form-control subject-management-create-input" formControlName="room"
          [readonly]="!sectionFieldsEditable" [class.is-invalid]="hasSectionError('room')" />
        <div class="invalid-feedback" *ngIf="hasSectionError('room')">กรุณากรอกข้อมูล</div>
      </div>

      <div class="subject-management-create-field subject-management-create-field-sm subject-management-create-section-field-students"
        *ngIf="!isProjectResearch">
        <label class="subject-management-create-label" [for]="'section-students-' + sectionIndex">
          จำนวนนักศึกษา <span aria-hidden="true">*</span>
        </label>
        <input [id]="'section-students-' + sectionIndex" type="text" inputmode="numeric" pattern="[0-9]*"
          autocomplete="off" class="form-control subject-management-create-input" formControlName="studentCount"
          [readonly]="!sectionFieldsEditable" [class.is-invalid]="hasSectionError('studentCount')" (keydown)="onDigitsOnlyKeydown($event)"
          (input)="onDigitsOnlyInput($event, section.get('studentCount'))" />
        <div class="invalid-feedback" *ngIf="hasSectionError('studentCount')">กรุณากรอกข้อมูล</div>
      </div>

      <div class="subject-management-create-field subject-management-create-field-sm subject-management-create-section-field-workload"
        *ngIf="!isProjectResearch">
        <label class="subject-management-create-label" [for]="'section-workload-' + sectionIndex">
          ชั่วโมงที่สอน (ไม่เกิน 15 สัปดาห์) <span *ngIf="workloadHoursEditable" aria-hidden="true">*</span>
        </label>
        <input [id]="'section-workload-' + sectionIndex" type="text" inputmode="decimal"
          autocomplete="off" class="form-control subject-management-create-input" formControlName="workloadHours"
          [readonly]="!workloadHoursEditable" [class.is-invalid]="workloadHoursEditable && hasSectionError('workloadHours')"
          (keydown)="workloadHoursEditable && onDecimalKeydown($event)"
          (input)="workloadHoursEditable && onDecimalInput($event, section.get('workloadHours'))" />
        <div class="invalid-feedback" *ngIf="workloadHoursEditable && hasSectionError('workloadHours')">กรุณากรอกข้อมูล</div>
      </div>

      <div class="subject-management-create-teaching-times" formArrayName="teachingTimes" *ngIf="!isProjectResearch">
        <div class="subject-management-create-teaching-time-row"
          *ngFor="let time of teachingTimes.controls; let timeIndex = index" [formGroupName]="timeIndex">
          <div class="subject-management-create-field subject-management-create-field-sm">
            <app-select label="วันที่สอน" formControlName="teachingDay" [required]="true"
              [options]="teachingDayOptions" [searchable]="false" [clearable]="true" [isDisabled]="!isTeachingTimeEditable(timeIndex)"
              [error]="hasTeachingTimeError(time, 'teachingDay')" errorMessage="กรุณากรอกข้อมูล"
              inputClass="subject-management-create-select" classes="mb-0"></app-select>
          </div>
          <div class="subject-management-create-field subject-management-create-time-field">
            <app-time-range-select [formGroup]="time" startControlName="startTime" endControlName="endTime"
              label="เวลาสอน" [required]="true" [options]="timeOptions"
              [startError]="hasTeachingTimeError(time, 'startTime')" [endError]="hasTeachingTimeError(time, 'endTime')"
              inputClass="subject-management-create-select" [isDisabledStart]="!isTeachingTimeEditable(timeIndex)"
              [isDisabledEnd]="!isTeachingTimeEditable(timeIndex)"></app-time-range-select>
          </div>
          <div class="subject-management-create-time-action-cell">
            <button *ngIf="timeIndex === 0" type="button"
              class="app-button app-button-outline subject-management-create-add-time-button"
              [disabled]="isAddTeachingTimeDisabled()" (click)="addTeachingTime.emit()">
              <span class="app-button-icon" aria-hidden="true">+</span>
              เพิ่มวัน และเวลาสอน
            </button>
            <button *ngIf="timeIndex > 0" type="button"
              class="app-button app-button-icon-only subject-management-create-remove-time-button"
              aria-label="ลบวันและเวลาสอน" [disabled]="!canRemoveTeachingTime(timeIndex)"
              [attr.title]="isTeachingTimeUsed(timeIndex) ? 'กรุณาลบช่วงวันที่สอนของอาจารย์ใน modal จัดการผู้สอนก่อนแก้ไขวันเวลา' : null"
              (click)="removeTeachingTime.emit(timeIndex)">
              <img src="assets/media/icons/svg/trush.svg" alt="" aria-hidden="true" />
            </button>
          </div>
        </div>
        <div class="subject-management-create-time-error"
          *ngIf="getTeachingTimesError() && (teachingTimes.dirty || teachingTimes.touched)">
          {{ getTeachingTimesError() }}
        </div>
      </div>
    </div>
  </ng-template>

  <div class="subject-management-create-teacher-header">
    <h5>รายชื่ออาจารย์ผู้สอน</h5>
    <button type="button" class="app-button app-button-outline subject-management-create-outline-button"
      [disabled]="teacherManagementDisabled" (click)="manageTeachers.emit()">
      <span class="app-button-icon subject-management-create-outline-button-icon" aria-hidden="true">+</span>
      {{ isProjectResearch ? 'เพิ่มผู้สอน' : 'จัดการผู้สอน' }}
    </button>
  </div>

  <div #teacherTableWrap class="subject-management-create-table-wrap"
    [class.subject-management-create-table-wrap-horizontal-overflow]="hasTeacherTableHorizontalOverflow">
    <table class="subject-management-create-table">
      <colgroup>
        <col class="subject-management-create-teacher-list-col-index" />
        <col class="subject-management-create-teacher-list-col-name" />
        <col class="subject-management-create-teacher-list-col-department" />
        <col class="subject-management-create-teacher-list-col-range" />
        <col class="subject-management-create-teacher-list-col-hours" />
        <col class="subject-management-create-teacher-list-col-updated" />
        <col class="subject-management-create-teacher-list-col-status" />
        <col class="subject-management-create-teacher-list-col-reason" />
        <col *ngIf="showProjectTeacherActionColumn" class="subject-management-create-teacher-list-col-action" />
      </colgroup>
      <thead>
        <tr>
          <th>ลำดับ</th><th>ชื่อ - นามสกุล</th><th>สาขาวิชา</th><th>ช่วงวันที่สอน</th>
          <th>ชั่วโมงที่สอน</th><th>วันที่อัปเดตสถานะ</th><th>สถานะรับรอง</th>
          <th>เหตุผลที่ส่งกลับแก้ไข</th>
          <th *ngIf="showProjectTeacherActionColumn" class="subject-management-create-teacher-action-header">จัดการ</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let teacher of teachers; let teacherIndex = index">
          <td>{{ teacherIndex + 1 }}</td>
          <td>{{ teacher.fullName }}</td>
          <td>{{ teacher.department }}</td>
          <td><div class="subject-management-create-teaching-range-list">
            <div *ngFor="let range of getTeachingRangeDisplayLines(teacher.teachingRange)">{{ range }}</div>
          </div></td>
          <td>{{ teacher.workloadHours }}</td>
          <td>{{ teacher.updatedAt }}</td>
          <td>
            <app-subject-management-status-badge
              *ngIf="teacher.status !== '-'; else emptyTeacherStatus"
              [label]="teacher.status"
              [status]="teacher.statusType ?? teacher.status"
              size="section"
            ></app-subject-management-status-badge>
            <ng-template #emptyTeacherStatus>-</ng-template>
          </td>
          <td>{{ teacher.returnReason }}</td>
          <td *ngIf="showProjectTeacherActionColumn" class="subject-management-create-teacher-action-cell">
            <div class="subject-management-create-teacher-action-buttons"
              *ngIf="showProjectTeacherActionButtons && isProjectTeacherEditable(teacherIndex)">
              <button type="button" class="app-button app-button-icon-only subject-management-create-teacher-action-button"
                aria-label="แก้ไขผู้สอน" (click)="editProjectTeacher.emit(teacherIndex)">
                <img src="assets/media/icons/svg/pencxil.svg" alt="" aria-hidden="true" />
              </button>
              <button type="button" class="app-button app-button-icon-only subject-management-create-teacher-action-button"
                aria-label="ลบผู้สอน" (click)="removeProjectTeacher.emit(teacherIndex)">
                <img src="assets/media/icons/svg/trush.svg" alt="" aria-hidden="true" />
              </button>
            </div>
          </td>
        </tr>
        <tr *ngIf="teachers.length === 0">
          <td [attr.colspan]="showProjectTeacherActionColumn ? 9 : 8" class="subject-management-create-empty">
            No data available in table
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="subject-management-create-submit-row">
    <button *ngIf="saveMode" type="button" class="app-button subject-management-create-submit-button"
      [disabled]="!editable || isSubmittingApproval" (click)="saveSection.emit()">
      บันทึก Section
    </button>
    <button *ngIf="!saveMode" type="button" class="app-button subject-management-create-submit-button"
      [disabled]="!editable || submitted || !approvalReady || isSubmittingApproval" (click)="submitApproval.emit()">
      ส่งขอรับรอง
    </button>
  </div>
  </div>
</div>
